export const domain = 'SubCategories';

// action types
export const IS_FETCHING = `${domain}/IS_FETCHING`;
export const FETCH_ERROR = `${domain}/FETCH_ERROR`;
export const RECEIVE_SUB_CATEGORIES = `${domain}/RECEIVE_SUB_CATEGORIES`;
export const TOGGLE_PRODUCTS_DISPLAY = `${domain}/TOGGLE_PRODUCTS_DISPLAY`;
export const TOGGLE_PRODUCTS_AND_CATEGORIES_DISPLAY = `${domain}/TOGGLE_PRODUCTS_AND_CATEGORIES_DISPLAY`;
export const UPDATE_RECENT_CAT = `${domain}/UPDATE_RECENT_CAT`;
export const UPDATE_SCROLL_POS = `${domain}/UPDATE_SCROLL_POS`;
export const SUB_CATEGORIES = 'subCategories';
